import { render } from "./SettingsKioskCardReload.vue?vue&type=template&id=12f47397"
import script from "./SettingsKioskCardReload.vue?vue&type=script&lang=js"
export * from "./SettingsKioskCardReload.vue?vue&type=script&lang=js"

import "./SettingsKioskCardReload.vue?vue&type=style&index=0&id=12f47397&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__